import React, { useState, useEffect, useContext, Fragment, useCallback } from 'react';

import Accordion from 'b2b-ui-components-lib/lib/components/accordion';
import Input from 'b2b-ui-components-lib/lib/components/input';
import Datepicker from 'b2b-ui-components-lib/lib/components/datePicker';
import Button from 'b2b-ui-components-lib/lib/components/button';
import Checkbox from 'b2b-ui-components-lib/lib/components/checkbox';

import FileUpload from '../FileUpload/poUpload';
import { formSchema, getDefaultValue, getDefaultFiles, ignoreKeys, purchaseOrderExpiryDateKey } from './FormControl';

import { isFormValid, getErrMsg } from 'home/view/upgrade-order/utils';

import { getCustomerDetail } from 'home/view/upgrade-order/utils';

import { CONTEXT } from 'home/view/upgrade-order/context';

import { DOCUMENT_TYPE_ENUM, TOAST_TYPE, LEAD_STATUS, ORDER_STATUS } from 'home/view/upgrade-order/constants';

import { deleteDocumentsAsync } from 'home/view/upgrade-order/services';
import { getPreviousYearDate, getRange, isFormTouched } from 'common/utils/app.utils';
import { FILE_MAX_SIZE, FILE_MAX_SIZE_MSG, ORDER_TYPE, PO_MAX_YEAR_BACK, isShiftingJourney } from 'common/constants/app.constants';
import { isOrderConfirmationUrl } from 'dedicated/services/summary.service';

const PurchaseDetailsSummary = ({ orderDetail }) => {
  const fileSchema = {
    supportedTypes: ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'],
    maxFileLimit: FILE_MAX_SIZE,
    documentNames: ['PO_DOCUMENT', 'PO_DOCUMENT_2', 'PO_DOCUMENT_3'],
    documentType: DOCUMENT_TYPE_ENUM.PURCHASE_ORDER,
    allowMultiplePDFs: true
  };

  //   const { setToastMsg, kycToken } = useContext(CONTEXT);

  const defaultFormState = getDefaultValue(orderDetail);

  const [form, setForm] = useState(defaultFormState);
  const [accordionMeta, setAccordionMeta] = useState({
    isExpanded: false
    //isValidated: false
  });
  const [defaultFileArr, setDefaultFileArr] = useState([]);
  const [checked, setChecked] = useState(true);
  const [uploadedFiles, setUploadedFiles] = useState([]);

  useEffect(() => {
    if (Object.keys(orderDetail).length > 0) {
      setDefaultFileArr(getDefaultFiles(orderDetail.documents));
      setForm(defaultFormState);
      setAccordionMeta({
        isExpanded: true
      });
    }
  }, [orderDetail]);

  //   const deleteUploadedFile = () => {
  //     Array.isArray(uploadedFiles) &&
  //       uploadedFiles.forEach(async (_, index) => {
  //         const documentName = fileSchema.documentNames[index];
  //         const payload = { documentType: fileSchema.documentType, documentName };

  //         try {
  //           const { res, err } = await deleteDocumentsAsync(payload, kycToken);

  //           if (res) {
  //             setUploadedFiles([]);
  //             setDefaultFileArr([]); // clear default files also after checkbox unchecked in PO details form
  //           } else if (err) {
  //             const errorMsg = getErrMsg(err);
  //             // setToastMsg(true, errorMsg, TOAST_TYPE.ERROR);
  //             throw new Error(errorMsg);
  //           }
  //         } catch (e) {
  //           console.error(e);
  //         }
  //       });
  //   };

  return (
    <div className="po-details upgrade-accordion">
      <Accordion
        autoScrollOnExpand={false}
        title={
          <Fragment>
            <div className="upgrade-header-open">
              <div className="title pad-bottom-0">Confirm Order Details</div>
              <label className="field_label">All fields are mandatory unless marked optional.</label>
            </div>
            <ul className="upgrade-header-closed">
              <Checkbox checked={checked} onChange={() => {}} disabled>
                <span className="check_text">Add PO details in my bill</span>
              </Checkbox>
            </ul>
          </Fragment>
        }
        isExpanded={accordionMeta.isExpanded}
        //isValidated={accordionMeta.isValidated}
        onExpandClick={() =>
          setAccordionMeta((accordionMeta) => ({
            ...accordionMeta,
            isExpanded: !accordionMeta.isExpanded
          }))
        }
        variant="round"
      >
        {checked && (
          <div className="accordion_body upgrade-body">
            <div className="order_details_form">
              <div className="row field_row">
                <div className="flg-lg-12 flg-md-12">
                  <div className="form_area">
                    <div className="row">
                      <div className="flg-lg-6 flg-md-6">
                        <Input label="Purchase Order Number" required touched value={form.purchaseOrderNo.value} disabled />
                      </div>
                      <div className="flg-lg-6 flg-md-6">
                        <Datepicker
                          name="datepicker"
                          label="Purchase Order Date"
                          required={true}
                          touched
                          value={form.purchaseOrderDate.value}
                          maxDate={new Date()}
                          minDate={getPreviousYearDate(PO_MAX_YEAR_BACK)}
                          years={getRange(getPreviousYearDate(PO_MAX_YEAR_BACK).getFullYear(), new Date().getFullYear())}
                          disabled
                        />
                      </div>

                      <div className="flg-lg-6 flg-md-6">
                        <Input type="text" label="Purchase Order Total Charges" required touched value={form.purchaseOrderTotalCharges.value} disabled />
                      </div>

                      {/* <div className="flg-lg-6 flg-md-6">
                        <Datepicker
                          name="datepicker"
                          label="Purchase Order Expiry Date (Optional)"
                          required={true}
                          touched
                          value={form.purchaseOrderExpiryDate.value}
                          maxDate={new Date(new Date().setYear(new Date().getFullYear() + 5))}
                          minDate={new Date()}
                          years={getRange(new Date().getFullYear(), new Date().getFullYear() + 5)}
                          disabled
                        />
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {checked && (
          // <div className="accordion_footer">
          <Fragment>
            <div className="upgrade-header-open">
              <div className="title pad-bottom-0">Upload Purchase Order</div>
              <label className="field_label">You can upload up-to 3 documents.</label>
            </div>
            <FileUpload
              onFileUploadSuccess={() => {}}
              label="Upload Purchase Order Document (upto 3 documents)"
              supportedLabel="Supported file format is .PDF, .PNG, .JPG"
              limitLabel={FILE_MAX_SIZE_MSG}
              fileSchema={fileSchema}
              defaultFiles={defaultFileArr}
              //   setToast={setToast}
              disabled
              multiple={true}
            ></FileUpload>
          </Fragment>
          // </div>
        )}
        {/* {showFooter() && (
          <div className="action_button">
            <Button variant="outlinebtn" displayName="Cancel" onClick={onCancelClick} disabled={isCancelDisabled()}></Button>
            <Button displayName="Next" disabled={loading || isSubmitDisabled()} onClick={handlePOSubmit}>
              {loading && <span className="loading_icon"></span>}
            </Button>
          </div>
        )} */}
      </Accordion>
    </div>
  );
};

export default PurchaseDetailsSummary;
